export enum FEATURE_FLAGS {
  VIZ_QUERY_WATCH = 'VIZ_QUERY_WATCH',
}
